import ManageAccessesScreen from "@components/Accesses/ManageAccessesScreen";

export default ManageAccessesScreen;
